import React from "react";
import DynamicForm from "components/DynamicForm";
import Proptypes from "prop-types";

function RecursiveGroupApprovalRemarks(props) {
  const { form_item, selectedData } = props;
  const group_approval_step_number = form_item?.group_approval_step_number;
  const arrayData = [];

  selectedData?.subworkFlowInfo?.[form_item?.form_field] &&
    Object.keys(selectedData?.subworkFlowInfo?.[form_item?.form_field]).map(
      (key) => {
        if (parseInt(key.split("_")?.[1]) === group_approval_step_number) {
          arrayData.push(
            selectedData?.subworkFlowInfo?.[form_item?.form_field][key]
          );
        }
        return null;
      }
    );


  return (
    <>
      {arrayData?.length
        ? arrayData?.map((data, i) => {
            return (
              <div key={`item_${i + 1}`} className="mb-3">
                <DynamicForm
                  formFields={{
                    ...form_item.form_elements,
                    input_fields: form_item.form_elements,
                    type: "group_approval_view_card",
                  }}
                  selectedData={{
                    ...selectedData,
                    ...data,
                  }}
                  tabIndex={-1}
                />
              </div>
            );
          })
        : null}
    </>
  );
}

RecursiveGroupApprovalRemarks.propTypes = {
  form_item: Proptypes.object,
  selectedData: Proptypes.object
};

export default RecursiveGroupApprovalRemarks;
